/**
 * Created by lency on 9/20/16.
 */
import angular from 'angular';

import clipboard from './clipboard.service';
import message from './message.service';
import badge from './badge/badge.service';
import pageTitle from './page-title.service';
import userLogin from './user-login.service';
import CRC32 from './CRC32.service';
import Jurisdiction from './Jurisdiction/jurisdiction.js';
import './previous-state';
import typeMap from './typemap'

let servicesModule = angular.module('app.services', ['ct.ui.router.extras.previous'])

    .service({
        clipboard,
        message,
        badge,
        pageTitle,
        userLogin,
        crc32: CRC32,
        Jurisdiction
    })
    .factory('$getCertLink', function (AppConfig) {
      'ngInject';
      return function (id) {
         console.log(`${AppConfig.server_url}/articles/package/${id}/ca/download`)
      //   return `${AppConfig.server_url}/articles/package/${id}/ca/download`
      }
    })
    .factory('$typeMap', typeMap)
    .name;

export default servicesModule;



// WEBPACK FOOTER //
// ./src/app/services/services.js